import { combineReducers } from 'redux';
import { createReducer } from '../utils';

const LOCKING_FORM_MODES = {
	LOCKING: 'LOCKING',
	GROUP: 'GROUP'
};

const OPEN_LOCKING_FORM = 'OPEN_LOCKING_FORM';
const CLOSE_LOCKING_FORM = 'CLOSE_LOCKING_FORM';

function doOpenLockingForm(formMode) {
	return {
		type: OPEN_LOCKING_FORM,
		formMode
	};
}

function doCloseLockingForm() {
	return { type: CLOSE_LOCKING_FORM };
}

const initialState = {
	isOpen: false,
	formMode: ''
};

const reducer = createReducer(initialState, {
	[OPEN_LOCKING_FORM]: (state, action) => ({
		isOpen: true,
		formMode: action.formMode
	}),
	[CLOSE_LOCKING_FORM]: (state, action) => initialState,
	SET_ACTIVE_LOCKING_ID: (state, action) => ({
		isOpen: true,
		formMode: action.locking.is_locking
			? LOCKING_FORM_MODES.LOCKING
			: LOCKING_FORM_MODES.GROUP
	}),
	RESET_ACTIVE_LOCKING_ID: (state, action) => initialState
});

function getLockingForm(state) {
	return state.app.lockingForm;
}

export default reducer;
export {
	LOCKING_FORM_MODES,
	doOpenLockingForm,
	doCloseLockingForm,
	getLockingForm
};



// WEBPACK FOOTER //
// ./src/js/reducers/app/lockingForm.js